/**
 * Static lookup tables for the rashi compatibility engine.
 * Consumed by rashi.ts — do not import directly in app code.
 */

// ─── Varna (Koota 1, max 1) ───────────────────────────────────────────────────

export const VARNA: Record<string, string> = {
  mesh: "kshatriya",
  vrishabh: "vaishya",
  mithun: "shudra",
  kark: "brahmin",
  singh: "kshatriya",
  kanya: "vaishya",
  tula: "shudra",
  vrishchik: "brahmin",
  dhanu: "kshatriya",
  makar: "vaishya",
  kumbh: "shudra",
  meen: "brahmin",
};

export const VARNA_RANK: Record<string, number> = {
  brahmin: 4,
  kshatriya: 3,
  vaishya: 2,
  shudra: 1,
};

// ─── Vashya (Koota 2, max 2) ──────────────────────────────────────────────────

export const VASHYA: Record<string, string> = {
  mesh: "chatushpad",
  vrishabh: "chatushpad",
  mithun: "manav",
  kark: "jalachara",
  singh: "vanachara",
  kanya: "manav",
  tula: "manav",
  vrishchik: "keeta",
  dhanu: "manav",
  makar: "jalachara",
  kumbh: "manav",
  meen: "jalachara",
};

export const VASHYA_MATRIX: Record<string, Record<string, number>> = {
  manav: { manav: 2, vanachara: 0, chatushpad: 1, jalachara: 0, keeta: 0 },
  vanachara: { manav: 0, vanachara: 2, chatushpad: 1, jalachara: 0, keeta: 0 },
  chatushpad: { manav: 1, vanachara: 0, chatushpad: 2, jalachara: 0, keeta: 0 },
  jalachara: { manav: 0, vanachara: 0, chatushpad: 0, jalachara: 2, keeta: 0 },
  keeta: { manav: 0, vanachara: 0, chatushpad: 0, jalachara: 0, keeta: 2 },
};

// ─── Graha Maitri (Koota 5, max 5) ───────────────────────────────────────────

export const P_FRIENDS: Record<string, string[]> = {
  sun: ["moon", "mars", "jupiter"],
  moon: ["sun", "mercury"],
  mars: ["sun", "moon", "jupiter"],
  mercury: ["sun", "venus"],
  jupiter: ["sun", "moon", "mars"],
  venus: ["mercury", "saturn"],
  saturn: ["mercury", "venus"],
};

export const P_ENEMIES: Record<string, string[]> = {
  sun: ["venus", "saturn"],
  moon: [],
  mars: ["mercury"],
  mercury: ["moon"],
  jupiter: ["mercury", "venus"],
  venus: ["sun", "moon"],
  saturn: ["sun", "moon", "mars"],
};

// ─── Bhakoot bad diffs (Koota 7, max 7) ──────────────────────────────────────

export const BHAKOOT_BAD = new Set([2, 5, 6]);

// ─── Element affinity (base score 0–9 for blended compatibility %) ────────────

export const ELEM_COMPAT: Record<string, number> = {
  "fire-fire": 8,
  "earth-fire": 4,
  "air-fire": 9,
  "fire-water": 3,
  "earth-earth": 7,
  "air-earth": 4,
  "earth-water": 8,
  "air-air": 7,
  "air-water": 4,
  "water-water": 8,
};

// ─── Dimension scores (0-100) per element pair ────────────────────────────────

export const DIM_EMOTIONAL: Record<string, number> = {
  "fire-fire": 65,
  "earth-fire": 50,
  "air-fire": 72,
  "fire-water": 60,
  "earth-earth": 75,
  "air-earth": 45,
  "earth-water": 85,
  "air-air": 68,
  "air-water": 52,
  "water-water": 90,
};

export const DIM_PHYSICAL: Record<string, number> = {
  "fire-fire": 80,
  "earth-fire": 75,
  "air-fire": 68,
  "fire-water": 70,
  "earth-earth": 88,
  "air-earth": 50,
  "earth-water": 82,
  "air-air": 55,
  "air-water": 48,
  "water-water": 78,
};

export const DIM_COMMUNICATION: Record<string, number> = {
  "fire-fire": 60,
  "earth-fire": 45,
  "air-fire": 88,
  "fire-water": 38,
  "earth-earth": 65,
  "air-earth": 58,
  "earth-water": 70,
  "air-air": 92,
  "air-water": 55,
  "water-water": 65,
};

export const DIM_FAMILY: Record<string, number> = {
  "fire-fire": 55,
  "earth-fire": 72,
  "air-fire": 58,
  "fire-water": 55,
  "earth-earth": 85,
  "air-earth": 65,
  "earth-water": 92,
  "air-air": 65,
  "air-water": 62,
  "water-water": 85,
};
